import { useQuery } from '@tanstack/react-query';
import { DirectReportsCompletionWidgetApiResponse } from 'abi-lcm-common-types';

import { lcmApi } from '~/shared/services/api';

export const GET_DIRECT_REPORTS_STATUS_QUERY_KEY =
  'homeV2/useGetDirectReportsStatus';

async function getDirectReportsStatus(): Promise<DirectReportsCompletionWidgetApiResponse> {
  const { data } = await lcmApi.get<DirectReportsCompletionWidgetApiResponse>(
    '/widgets/results/direct-report-status'
  );

  return data;
}

export function useGetDirectReportsStatus() {
  return useQuery({
    queryKey: [GET_DIRECT_REPORTS_STATUS_QUERY_KEY],
    queryFn: getDirectReportsStatus,
  });
}
